import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useTranslation } from "react-i18next";

const WishlistHeader = ({
  itemCount,
  viewMode,
  onViewModeChange,
  isSelectionMode,
  onToggleSelectionMode,
  selectedCount,
  onClearAll,
}) => {
   const { t } = useTranslation();
  return (
    <div className="bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          {/* Title and Count */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name="Heart" size={20} className="text-accent" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-text-primary">
                {t("wishlist")}
              </h1>
              <p className="text-sm text-text-secondary">
                {itemCount} {itemCount === 1 ? t("item") : t("from_items")} {t("saved")}
              </p>
            </div>
          </div>

       
        </div>
      </div>
    </div>
  );
};

export default WishlistHeader;
